import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, w100} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {priceFormat} from "@pg-mono/string-utils";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {getCurrency} from "../../utils/get_currency";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {isPropertyWithDiscountPrice} from "../utils/is_property_with_discount_price";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPrice = (props: IProps) => {
    const {property} = props;

    const hasDiscountPrice = isPropertyWithDiscountPrice(property);
    const forceShowPrice = property.offer.vendor.configuration.force_show_price;
    const currency = getCurrency({currency: property.offer.currency});
    const source = forceShowPrice || (property.configuration.show_price && !!property.price) ? ApplicationSource.Property : ApplicationSource.PriceInquiry;

    return (
        <ApplicationModalButton
            source={source}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={property.offer.vendor.id}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={getOfferDisplayStatus(property.offer) === "limited"}
            render={({openModal}) => (
                <div css={priceButtonWrap}>
                    {hasDiscountPrice || (forceShowPrice && property.price && property.price > 0) ? (
                        <>
                            <Button onClick={openModal} variant="outlined_secondary" css={w100}>
                                {priceFormat(property.price as number, {unit: currency})}
                                {property.price_m2 && (
                                    <Text variant="info_txt_2" align="center">
                                        {priceFormat(property.price_m2, {unit: currency})} / m2
                                    </Text>
                                )}
                            </Button>
                            {hasDiscountPrice && (
                                <div css={discountPriceInfo}>
                                    <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                                    <Text variant="info_txt_2" align="center">
                                        Najniższa cena z ostatnich 30 dni, przed obniżką:{" "}
                                        <strong>{priceFormat(property.lowest_price_within_30_days as number)}</strong>
                                    </Text>
                                </div>
                            )}
                        </>
                    ) : (
                        <Button onClick={openModal} variant="outlined_secondary" css={w100} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            {InquiryButtonTypeName.PRICE}
                        </Button>
                    )}
                </div>
            )}
        />
    );
};

//  Styles
const priceButtonWrap = css`
    display: flex;
    flex-direction: column;
    row-gap: ${calculateRemSize(1)};
`;

const discountPriceInfo = css`
    max-width: 193px;
    display: flex;
    column-gap: ${calculateRemSize(0.5)};
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, w100} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {priceFormat} from "@pg-mono/string-utils";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {getCurrency} from "../../utils/get_currency";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {isPropertyWithDiscountPrice} from "../utils/is_property_with_discount_price";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPrice = (props: IProps) => {
    const {property} = props;

    const hasDiscountPrice = isPropertyWithDiscountPrice(property);
    const forceShowPrice = property.offer.vendor.configuration.force_show_price;
    const currency = getCurrency({currency: property.offer.currency});
    const source = forceShowPrice || (property.configuration.show_price && !!property.price) ? ApplicationSource.Property : ApplicationSource.PriceInquiry;

    return (
        <ApplicationModalButton
            source={source}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={property.offer.vendor.id}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={getOfferDisplayStatus(property.offer) === "limited"}
            render={({openModal}) => (
                <div css={priceButtonWrap}>
                    {hasDiscountPrice || (forceShowPrice && property.price && property.price > 0) ? (
                        <>
                            <Button onClick={openModal} variant="outlined_secondary" css={w100}>
                                {priceFormat(property.price as number, {unit: currency})}
                                {property.price_m2 && (
                                    <Text variant="info_txt_2" align="center">
                                        {priceFormat(property.price_m2, {unit: currency})} / m2
                                    </Text>
                                )}
                            </Button>
                            {hasDiscountPrice && (
                                <div css={discountPriceInfo}>
                                    <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                                    <Text variant="info_txt_2" align="center">
                                        Najniższa cena z ostatnich 30 dni, przed obniżką:{" "}
                                        <strong>{priceFormat(property.lowest_price_within_30_days as number)}</strong>
                                    </Text>
                                </div>
                            )}
                        </>
                    ) : (
                        <Button onClick={openModal} variant="outlined_secondary" css={w100} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            {InquiryButtonTypeName.PRICE}
                        </Button>
                    )}
                </div>
            )}
        />
    );
};

//  Styles
const priceButtonWrap = css`
    display: flex;
    flex-direction: column;
    row-gap: ${calculateRemSize(1)};
`;

const discountPriceInfo = css`
    max-width: 193px;
    display: flex;
    column-gap: ${calculateRemSize(0.5)};
`;
